import axios from 'axios';
import {
  Task,
  Organization,
  Release,
  SolutionVersion,
  Solution,
  User,
} from '../types';

type RoadmapPayloadRelease = Omit<Release, 'releaseDate'> & {
  releaseDate: string;
};

type RoadmapPayload = {
  user: User | null;
  fromDate: string;
  toDate: string;
  tasks: Task[];
  organizations: Organization[];
  releases: RoadmapPayloadRelease[];
  solutionVersions: SolutionVersion[];
  solutions: Solution[];
}

export type RoadmapResult = {
  user: User | null;
  tasks: Task[];
  organizations: Organization[];
  releases: Release[];
  solutionVersions: SolutionVersion[];
  solutions: Solution[];
};

const Api = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    'X-Client': 'solution',
    'Pragma': 'no-cache',
    'Cache-Control': 'no-cache',
  },
});

type FetchDataParams = {
  fromDate?: Date;
  toDate?: Date;
};

export const fetchData = async (params: FetchDataParams = {}): Promise<RoadmapResult> => {
  const { data } = await Api.get<RoadmapPayload>('/Search', {
    params: {
      fromDateTime: params.fromDate?.toISOString(),
      toDateTime: params.toDate?.toISOString(),
    },
  });

  return {
    ...data,
    releases: data.releases.map((release) => ({
      ...release,
      releaseDate: new Date(release.releaseDate),
    })),
  };
};

export const login = async (token: string): Promise<void> => {
  await Api.post('/authentication/login', { token });
};

export const logout = async (): Promise<void> => {
  await Api.post('/authentication/logout');
};
